<template>
  <v-container>
    <v-row v-if="errorMessage">
      <v-col cols="12">
        <message-alert :message="errorMessage" alert-type="error" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="registrationDetails.first_name"
          class="required-field"
          :label="t('First Name')"
          :error-messages="getErrorMessages('first_name')"
          prepend-icon="mdi-account"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="registrationDetails.last_name"
          class="required-field"
          :label="t('Last Name')"
          :error-messages="getErrorMessages('last_name')"
          prepend-icon="mdi-account-tie"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="registrationDetails.email"
          class="required-field"
          :label="t('Email Address')"
          :error-messages="getErrorMessages('email')"
          prepend-icon="mdi-email"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="registrationDetails.cellphone_number"
          class="required-field"
          :label="t('Cellphone Number')"
          :error-messages="getErrorMessages('cellphone_number')"
          type="number"
          prepend-icon="mdi-cellphone"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="registrationDetails.telephone_number"
          :label="t('Telephone Number')"
          :error-messages="getErrorMessages('telephone_number')"
          type="number"
          prepend-icon="mdi-phone"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-select
          v-model="registrationDetails.country_id"
          class="required-field"
          :items="countryList"
          :label="t('Country of Residence')"
          :error-messages="getErrorMessages('country_id')"
          prepend-icon="mdi-flag"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-select
          v-model="registrationDetails.sector_id"
          :items="sectorList"
          :label="t('Sector')"
          :error-messages="getErrorMessages('sector_id')"
          prepend-icon="mdi-chart-bar"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="showOtherSector">
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="registrationDetails.sector_other"
          class="required-field"
          label="Other Sector"
          :error-messages="getErrorMessages('sector_other')"
          prepend-icon="mdi-chart-bar"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="registrationDetails.gender"
          class="required-field"
          :items="genderList"
          :label="t('Gender')"
          :error-messages="getErrorMessages('gender')"
          prepend-icon="mdi-gender-male-female"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="registrationDetails.age_id"
          class="required-field"
          :items="ageList"
          :label="t('Age')"
          :error-messages="getErrorMessages('age_id')"
          prepend-icon="mdi-calendar"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          class="required-field"
          @click:append="changeShowPassword"
          :type="showPassword ? 'text' : 'password'"
          v-model="registrationDetails.password"
          :label="t('Password')"
          :error-messages="getErrorMessages('password')"
          prepend-icon="mdi-lock"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
          class="required-field"
          @click:append="changeShowPasswordConfirm"
          :type="showPasswordConfirm ? 'text' : 'password'"
          v-model="registrationDetails.password_confirmation"
          :label="t('Confirm Password')"
          :error-messages="getErrorMessages('password_confirmation')"
          prepend-icon="mdi-lock"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn
          :disabled="!canRegister"
          color="#f2a41f"
          class="mr-4"
          @click="register"
          block
          large
        >
          {{ t("Register") }}
        </v-btn>
      </v-col>
    </v-row>
    <overlay-custom
      :active="loading"
      :message="loadingMessage"
    ></overlay-custom>
  </v-container>
</template>

<script>
import MessageAlert from "../components/alert/MessageAlert";
import { mapState } from "vuex";
import { isEmpty, isNull, map } from "lodash";
import { mapErrors } from "@/lib/formUtils";
import OverlayCustom from "../components/OverlayCustom";

export default {
  name: "RegisterView",
  components: { OverlayCustom, MessageAlert },
  data() {
    return {
      registrationDetails: {
        first_name: null,
        last_name: null,
        cellphone_number: null,
        telephone_number: null,
        email: null,
        password: null,
        password_confirmation: null,
        country_id: null,
        sector_id: null,
        sector_other: null,
        gender: null,
        age_id: null,
      },
      showPasswordConfirm: false,
      showPassword: false,
      errors: [],
      errorMessage: null,
      loading: false,
      loadingMessage: null,
      genderList: [
        {
          text: this.t("Female"),
          value: "Female",
        },
        {
          text: this.t("Male"),
          value: "Male",
        },
      ],
    };
  },
  computed: {
    ageList() {
      return map(
        !isNull(this.lookups) ? this.lookups.ages : [],
        function (lookup) {
          return {
            text: lookup.description,
            value: lookup.id,
          };
        }
      );
    },
    countryList() {
      return map(
        !isNull(this.lookups) ? this.lookups.countries : [],
        function (lookup) {
          return {
            text: lookup.name,
            value: lookup.id,
          };
        }
      );
    },
    sectorList() {
      return map(
        !isNull(this.lookups) ? this.lookups.sectors : [],
        function (lookup) {
          return {
            text: lookup.name,
            value: lookup.id,
          };
        }
      );
    },
    ...mapState({
      lookups: (state) => state.lookups,
    }),
    showOtherSector() {
      return "other" === this.registrationDetails.sector_id;
    },
    canRegister() {
      return (
        !isEmpty(this.registrationDetails.first_name) &&
        !isEmpty(this.registrationDetails.last_name) &&
        !isEmpty(this.registrationDetails.cellphone_number) &&
        !isEmpty(this.registrationDetails.email) &&
        !isEmpty(this.registrationDetails.gender) &&
        this.registrationDetails.age_id > 0 &&
        !isEmpty(this.registrationDetails.password) &&
        !isEmpty(this.registrationDetails.password_confirmation) &&
        !isEmpty(this.registrationDetails.country_id) &&
        ((this.showOtherSector &&
          !isEmpty(this.registrationDetails.sector_other)) ||
          !this.showOtherSector)
      );
    },
  },
  methods: {
    changeShowPasswordConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },
    changeShowPassword() {
      this.showPassword = !this.showPassword;
    },
    async register() {
      const that = this;
      that.errorMessage = null;
      that.errors = [];
      that.loading = true;
      that.loadingMessage = that.t("Registering...");

      this.$store
        .dispatch("register", this.registrationDetails)
        .then(() => {
          that.$router.push({
            name: "login",
            query: {
              popup: "true",
              message: that.t("Registration complete!"),
              type: "info",
            },
          });
        })
        .catch((error) => {
          that.mapErrors(error.data);
        })
        .finally(() => {
          that.loading = false;
          that.loadingMessage = null;
        });
    },
    mapErrors(errorDetails) {
      this.errors = mapErrors(errorDetails);
      this.errorMessage = errorDetails.message;
    },
    hasError(field) {
      return !isEmpty(this.errors[field]);
    },
    getErrorMessages(field) {
      return this.errors[field];
    },
  },
};
</script>

<style scoped>
div >>> .error--text {
  margin-bottom: 5px !important;
}
.required-field >>> label::before {
  content: "* ";
  color: red;
}
</style>
